'use client'

import Image from 'next/image'
import {
  Container,
  Reveal,
  Section,
  SectionHeader,
  Stagger,
} from 'design-studio'

const DIAGRAM_VIEWBOX_WIDTH = 672
const DIAGRAM_VIEWBOX_HEIGHT = 304
const REASONING_DIAGRAM_ALT =
  'Diagram showing the reasoning loop between the LLM coding agent, SpecLogician, ImandraX, reasoning artifacts, and the human developer'

export function SectionReasoningLoop() {
  return (
    <Section
      id="reasoning-loop"
      className="relative scroll-mt-19 bg-zinc-200 py-16 backdrop-blur-md sm:pt-24 sm:pb-32 dark:bg-slate-800/10"
    >
      <Container className="relative z-10 max-w-6xl">
        <Stagger className="space-y-10">
          <Reveal>
            <SectionHeader
              pretitle="Reasoning loop"
              pretitleColor="text-teal-500"
              title="How Agents, SpecLogician, and ImandraX Work Together"
              description="When prompt-local reasoning is not enough, LLM coding agents use SpecLogician to discover behavioral structure, refine it into mathematical context, invoke reasoning, and act on the evidence."
            />
          </Reveal>

          <Reveal>
            <div className="mx-auto max-w-4xl overflow-hidden">
              <Image
                src="/images/sl-diag-2-light.svg"
                alt={REASONING_DIAGRAM_ALT}
                width={DIAGRAM_VIEWBOX_WIDTH}
                height={DIAGRAM_VIEWBOX_HEIGHT}
                className="h-auto w-full dark:hidden"
              />
              <Image
                src="/images/sl-diag-2-dark.svg"
                alt={REASONING_DIAGRAM_ALT}
                width={DIAGRAM_VIEWBOX_WIDTH}
                height={DIAGRAM_VIEWBOX_HEIGHT}
                className="hidden h-auto w-full dark:block"
              />
            </div>
          </Reveal>
        </Stagger>
      </Container>
    </Section>
  )
}
